// src/store/sidebarStore.ts
import { create } from 'zustand';

interface SidebarState {
  isExpanded: boolean;
  isMobileOpen: boolean;
  toggle: () => void;
  setMobileOpen: (open: boolean) => void;
}

export const useSidebarStore = create<SidebarState>((set) => ({
  isExpanded: true,
  isMobileOpen: false,
  toggle: () => set((state) => ({ isExpanded: !state.isExpanded })),
  setMobileOpen: (open) => set({ isMobileOpen: open }),
}));